// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__94WXD","questions":"styles_questions__omdrw","footer":"styles_footer__A0MBt"};